<template>
  <div class="card text-center">
    <div
      class="card-header d-flex"
      :style="{
        backgroundColor: isPending ? '#ffc107' : 'black',
        padding: '10px',
        color: 'white',
      }"
    >
      <h5 class="flex-grow-1">Discover</h5>
      <button
        v-if="!isPending && !isApprover"
        class="float-right btn btn-info editDiscoverBanner"
        data-bs-toggle="modal"
        data-bs-target="#editDiscoverBanner"
      >
        <i class="fa fa-pencil text-white"></i>
      </button>
      <span v-if="isPending" class="float-right btn bg-secondary"
        ><i class="fa fa-lock text-white"></i
      ></span>
    </div>
    <div class="card-body">
      <div
        style="
          border: dashed 1px black;
          padding: 20px;
          display: flex;
          flex-direction: row;
          gap: 20px;
        "
      >
        <div v-for="(discover, index_disc) in discovers" :key="index_disc">
          <img
            :src="discover.image_url"
            style="
              width: 200px;
              height: 150px;
              object-fit: cover;
              border-radius: 10px;
              box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
            "
          />
        </div>
      </div>
      <div class="float-right">
        <button @click="preview()" class="btn text-dark bg-light-dark m-2">Preview</button>
        <button
          v-if="!isApprover && !isPending"
          @click="saveDiscoverBanner(0)"
          class="btn bg-light-dark text-dark m-2"
        >
          Save Draft
        </button>
        <button
          v-if="!isApprover && !isPending"
          @click="saveDiscoverBanner(1)"
          class="btn btn-warning text-dark text-dark m-2"
        >
          Submit For Approval
        </button>
        <button
          v-if="isApprover && isPending"
          data-bs-toggle="modal"
          data-bs-target="#approveModal"
          class="btn btn-warning text-dark m-2 approveModal"
          @click="openDiscoverApproval(index_1, 'discover')"
        >
          Approval
        </button>
      </div>
    </div>
  </div>

  <!-- modal component -->
  <div>
    <Modal
      :modalTitle="'Edit Discover'"
      :modalSize="'modal-lg'"
      :id="'editDiscoverBanner'"
    >
      <div class="card text-dark">
        <div class="card-body">
          <div class="default-according style-1" id="accordionoc1">
            <div
              v-for="(discover, index_2) in discovers"
              :key="index_2"
              class="w-full d-flex gap-2 py-2"
            >
              <div class="card w-100">
                <div class="card-header bg-light-dark text-dark">
                  <h5 class="mb-0">
                    <button
                      class="btn text-dark bg-light-dark w-100"
                      :class="{ collapsed: !discover.discover_expanded }"
                      data-bs-toggle="collapse"
                      :data-bs-target="'#collapseicon' + index_2"
                      aria-expanded="true"
                      :aria-controls="`collapseicon${index_2}`"
                    >
                      <span>{{ discover.title }}</span>
                    </button>
                  </h5>
                </div>
                <div
                  :class="['collapse', { show: discover.discover_expanded }]"
                  :id="`collapseicon${index_2}`"
                  :aria-labelledby="`collapseicon${index_2}`"
                  data-bs-parent="#accordionoc1"
                >
                  <div class="card-body">
                    <div style="display: flex; flex-direction: column">
                      <label class="form-label speedee-bold float-left"
                        >Image</label
                      >
                      <div
                        style="
                          display: flex;
                          flex-direction: row;
                          align-items: center;
                        "
                      >
                        <img
                          :src="discover.image_url"
                          style="
                            width: 120px;
                            height: 120px;
                            object-fit: contain;
                            border-radius: 10px;
                            border: dashed 1px gray;
                          "
                        />
                        <div class="fileUpload bg-none text-left align-middle">
                          <div>
                            <span class="media-text p-2"
                              >Select from Media Library (Max dimension 1200 x
                              800 px)</span
                            >
                          </div>
                          <button
                            @click="
                              openGalleryDModal(index_2, 'editDiscoverBanner')
                            "
                            aria-hidden="true"
                            class="mx-2 p-2 border w-auto"
                          >
                            Browse
                          </button>
                        </div>
                      </div>
                    </div>

                    <label class="form-label speedee-bold float-left"
                      >Description</label
                    >
                    <input
                      type="text"
                      id="discover_title"
                      class="form-control mb-4"
                      v-model="discover.description"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <button
            type="button"
            class="btn bg-light-dark text-dark mt-4 float-right mx-2"
            data-bs-dismiss="modal"
          >
            Cancel
          </button>
          <button
            id="DiscoverSaveModalBtn"
            class="btn btn-warning text-dark mt-4 float-right"
            data-bs-dismiss="modal"
          >
            Done
          </button>
        </div>
      </div>
    </Modal>
  </div>
</template>


<script>
import Modal from "@/components/ModalComponent.vue";
import { getRequest, postRequest } from "@/services/RequestService";

export default {
  props: {
    discovers: {
      type: Array, // Adjust the prop type based on your data structure
      required: true,
    },
    isApprover: {
      type: Boolean, // Adjust the prop type based on your data structure
      required: true,
    },
    isPending: {
      type: Boolean, // Adjust the prop type based on your data structure
      required: true,
    },
    isApproved: {
      type: Boolean, // Adjust the prop type based on your data structure
      required: true,
    },
  },
  components: {
    Modal,
  },

  methods: {
    openDiscoverApproval(index, modalName) {
      document.getElementById("data_id").value = modalName;
    },
    /**** gallery modal ****/

    openGalleryDModal(index, modalName) {
      var discoverBannerModal = document.getElementById(modalName);
      var galleryModal = document.getElementById("galleryModal");
      var index = (document.getElementById("slideIndex").value = index);
      document.getElementById("modal_id").value = modalName;

      discoverBannerModal.classList.remove("show");
      discoverBannerModal.style.display = "none";

      galleryModal.classList.add("show");
      galleryModal.style.display = "block";
    },

    /*** end of gallery modal function ***/

    /*** save function ***/
    async saveDiscoverBanner(type) {
      //iterate through the array of data
      let discovers = this.discovers.map((discover) => ({
        id: discover.id,
        title: discover.title,
        description: discover.description,
        gallery_id: discover.image_id,
      }));

      let response = await postRequest(
        "/discovers",
        { items: discovers, approval: type },
        true
      );

      if (response.data.success) {
        this.$swal({
          icon: response.data.success ? "success" : "error",
          text: response.data.message,
          confirmButtonText: "Close",
        }).then(function () {
          window.location.reload();
        });
      }
    },

    async preview() {
      if (this.isPending ||(this.isApprover && this.isApproved)) {
        window.open("/?preview=1");
      } else {
        let discovers = this.discovers.map((discover) => ({
          id: discover.id,
          title: discover.title,
          description: discover.description,
          gallery_id: discover.image_id,
        }));

        let response = await postRequest(
          "/discovers",
          { items: discovers, approval: 0 },
          true
        );

        if (response.data.success) {
          window.open("/?preview=1");
          location.reload();
        } else {
          this.$swal({
            icon: "error",
            text: response.data.message,
            confirmButtonText: "Close",
          }).then(async () => {
            window.open("/?preview=1");
          });
        }
      }
    },
  },

  data() {
    return {
      text: {
        title: "Discover",
      },
    };
  },
};
</script>

<style scoped>
input[type="file"]::file-selector-button {
  border: none;
  background: lightgray;
  padding: 10px 20px;
  border-radius: 10px;
  color: black;
  cursor: pointer;
  transition: background 0.2s ease-in-out;
}

input[type="file"]::file-selector-button:hover {
  background: lightgray;
  color: black;
}

.banner-item {
  width: 100%;
}

.newSlideBtn {
  width: 94% !important;
}
</style>